<script lang="ts">
  import { Doc } from '@dabble/data/types';
  import Page from '@dabble/toolkit/Page.svelte';

  export let doc: Doc;
</script>

<Page {doc} />
